export default "__VITE_PUBLIC_ASSET__08e4f94e__"